import styled from '@emotion/styled'
import { theme, MediaQueries } from '@hhgtech/hhg-components/misc'
// import { deviceLayout } from 'styles/breakpoint'

export const StyledContainer = styled.div`
  background-color: ${theme.colors.neutral50};
`

export const StyleFeaturedTopics = styled.div`
  width: 100%;
  ${MediaQueries.mbUp} {
    padding: 0 16px 72px;

    &[data-is-expert-page] {
      padding: 0;
    }
  }

  background-color: ${theme.colors.white};

  ${MediaQueries.mbDown} {
    padding-bottom: 48px;
    & > :first-of-type {
      padding: 48px 16px 0;
    }
  }
`

export const StyledHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${MediaQueries.mbUp} {
    padding: 80px 0 32px;
  }

  & > div > [data-tag='h3'] {
    line-height: 32px;
  }
`

export const StyledFeatureSmallArticleContainer = styled.div`
  ${MediaQueries.mbUp} {
    padding: 16px;
  }

  background-color: ${theme.colors.white};
`

export const StyledFeatureTopicSeeMore = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 8px 0;
  background-color: ${theme.colors.white};
  cursor: pointer;

  .see-more-text {
    pointer-events: none;
    color: ${theme.colors.primaryBase};
  }

  & > :first-of-type {
    margin-right: 4px;
  }

  ${MediaQueries.mbUp} {
    padding: 0;
    width: auto;

    & > div > [data-tag='h5'] {
      font-weight: bold;
      line-height: 24px;
      font-size: ${theme.sizes.fsHeading6};
    }
  }
`

export const StyledArticlesContainer = styled.div`
  margin-top: 8px;

  & > :not(:last-child) {
    margin-bottom: 8px;
  }

  background-color: ${theme.colors.neutral50};
`

export const StyledArticleContainer = styled.div`
  ${MediaQueries.mbUp} {
    padding: 24px 16px;
  }

  ${MediaQueries.mbDown} {
    padding: 24px 0;
  }

  background-color: ${theme.colors.white};

  .banner {
    width: 100%;
    min-height: 192px;
  }
`

export const StyledArticlesDesktopContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`

export const StyledHeroContainer = styled.div`
  width: 100%;
  max-width: 600px;

  margin-bottom: 32px;
  //align-self: stretch;
  //display: flex;
  //justify-content: stretch;

  //justify-self: stretch;

  background-color: ${theme.colors.white};

  & > div > div {
    height: 100%;
  }

  .banner {
    min-height: 312px;
  }
`

export const StyledSmallArticleDesktopContainer = styled.div`
  background-color: ${theme.colors.white};
  .desktop-article[data-type='group1'][data-size='sm'] > .banner {
    width: 150px;
    height: 100px;
  }
`

export const StyledSubColumnContainer = styled.div`
  display: flex;
  width: 100%;
  //align-items: stretch;

  //align-self: stretch;
  //flex: 1;
  //flex-direction: column;
  //justify-content: center;
  //justify-self: stretch;
  //margin-left: 32px;

  background-color: ${theme.colors.white};

  & > :first-of-type {
    margin-right: 32px;
  }

  & > div {
    flex: 1;
  }
`

export const StyledArticlesSkeleton = styled.div`
  width: 100%;
`
